// Reusable switch. Knob uses logical start/end so it mirrors under RTL.
import { cn } from '../../lib/cn';

export default function Toggle({
  on,
  onChange,
  label,
}: {
  on: boolean;
  onChange: (next: boolean) => void;
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      onClick={() => onChange(!on)}
      className={cn(
        'relative h-[21px] w-[38px] flex-shrink-0 rounded-full transition-colors',
        on ? 'bg-accent' : 'bg-slate-300',
      )}
    >
      <span
        className={cn(
          'absolute top-[2.5px] h-4 w-4 rounded-full bg-white shadow-sm transition-all',
          on ? 'end-[3px]' : 'start-[3px]',
        )}
      />
    </button>
  );
}
